export const ROUTE_NAMES = {
  TOPIC_MANAGEMENT: 'topic-management',
  TOPICS: 'topics',
  TOPIC_VIDEOS: 'topic-videos',

  CHANNEL: 'channel',
  CHANNELS: 'channels',

  SCENE: 'scene',
  SCENES: 'scenes',

  BANNER: 'banner',
};
